import CitySEOHead from "@/components/feature/CitySEOHead";
import BossierCityHeroSection from "./components/HeroSection";
import BossierCityStickyNav from "./components/StickyNav";
import BossierCityProcessingTimeSection from "./components/ProcessingTimeSection";
import BossierCityServicesSection from "./components/ServicesSection";
import BossierCityLocalAreaSection from "./components/LocalAreaSection";
import BossierCityTestimonialsSection from "./components/TestimonialsSection";
import BossierCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BossierCityComparisonSection from "./components/ComparisonSection";
import BossierCityMistakesSection from "./components/MistakesSection";
import BossierCityHowItWorksSection from "./components/HowItWorksSection";
import BossierCityFAQSection, { faqs } from "./components/FAQSection";
import BossierCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BossierCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import BossierCityTravelTimingSection from "./components/TravelTimingSection";
import BossierCityDestinationsSection from "./components/DestinationsSection";

const pageTitle = "Emergency Passport Bossier City, LA — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Bossier City, LA — as fast as 24 hours. Serving Barksdale AFB military families, casino industry professionals, and Bossier Parish residents. A+ BBB rated, registered State Dept. courier.";

export default function BossierCityPage() {
  return (
    <>
      <CitySEOHead
        city="Bossier City"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/bossier-city"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bossier City, Louisiana"
        geoPosition="32.5160;-93.7321"
        keywords="expedited passport Bossier City, emergency passport Bossier City LA, Barksdale AFB passport, fast passport Louisiana, passport renewal Bossier City, Bossier Parish passport"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
        lastModified="2026-06-09"
        serviceAreaDesc="Emergency and expedited passport services for Bossier City, Barksdale AFB, and the Shreveport-Bossier metro."
      />

      <div className="font-sans">
        <BossierCityHeroSection />
        <BossierCityStickyNav />
        <BossierCityProcessingTimeSection />
        <BossierCityServicesSection />
        <BossierCityLocalAreaSection />
        <BossierCityTravelTimingSection />
        <BossierCityDestinationsSection />
        <BossierCityTestimonialsSection />
        <BossierCityAcceptanceFacilitiesSection />
        <BossierCityComparisonSection />
        <BossierCityMistakesSection />
        <BossierCityHowItWorksSection />
        <BossierCityFAQSection />
        <BossierCityHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/bossier-city" state="LA" />
        <BossierCityFinalCTA />
      </div>
    </>
  );
}